<template>
  <div class="video-player">
    <div v-if="!isPlaying" class="video-player__overlay">
      <div class="video-player__info">
        <h2
          v-if="videoHeading !== ''"
          class="heading--separator left text-KQ-White m-b--16"
        >
          {{ videoHeading }}
        </h2>
        <p v-if="videoDescription !== ''" class="text-KQ-White m-b--24">
          {{ videoDescription }}
        </p>
        <button
          role="button"
          aria-label="Play Video"
          class="button button--iconleft"
          @click="playVideo"
        >
          <i class="icon icon-play-video icon--xs" aria-hidden="true"></i>Play
          Video
        </button>
      </div>
      <div class="video-player__info-mobile display-sm--none">
        <button
          role="button"
          aria-label="Play Video"
          class="button"
          @click="playVideo"
        >
          <i class="icon icon-play-video icon--xs" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div v-if="isPlaying" class="video-player__frame">
      <template v-if="localVideo">
        <slot name="localvideo"></slot>
      </template>
      <template v-else>
        <iframe :src="videoUrl" title="Video" allowfullscreen></iframe>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VideoEmbed',
  props: {
    videoId: {
      type: String,
      default: '',
    },
    videoHeading: {
      type: String,
      default: '',
    },
    videoDescription: {
      type: String,
      default: '',
    },
    provider: {
      type: String,
      default: '',
    },
    localVideo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPlaying: false,
      videoUrl: '',
    };
  },
  methods: {
    playVideo() {
      this.isPlaying = true;
      this.videoUrl = this.getVideoUrl() + '?autoplay=1';
    },
    getVideoUrl() {
      const providers = {
        youtube: 'https://www.youtube.com/embed/',
        vimeo: 'https://player.vimeo.com/video/',
      };
      const baseUrl = providers[this.provider];
      let params = '';
      if (this.provider === 'youtube') {
        params +=
          '?autoplay=1&color=#FA8334&modestbranding=1&playsinline=1&rel=0';
      } else if (this.provider === 'vimeo') {
        params += '?autopause=1&?autoplay=1&color=#FA8334&playsinline=1';
      }
      params += '&muted=1';
      return `${baseUrl}${this.videoId}${params}`;
    },
  },
};
</script>
